module.exports = __webpack_public_path__ + "static/img/banner_fenghui.432add0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/banner_fenghui.png
// module id = OV7V
// module chunks = 16